import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetTypesUser = async () => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/getOrganizationUserTypeCorpEntities'

  return axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
